"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { userService } from "@/services/user.service";

export function checkIsLogged(redirectURL = "") {
	const pathname = usePathname();
	
	useEffect(() => {
		// Skip verificarea dacă suntem pe calculator-taxe
		if (pathname === '/calculator-taxe' || pathname === '/delete-acc' || pathname === '/termeni-si-conditii' || pathname === '/politica-de-confidentialitate' || pathname === '/politica-cookies') {
			return;
		}
		
		const loggedIn = !!userService.userValue;
		if (loggedIn && redirectURL) {
			window.location.href = redirectURL;
		}
	}, [redirectURL, pathname]);

	return !!userService.userValue;
}

export function checkIsNotLogged(redirectURL = "") {
	const pathname = usePathname();
	
	useEffect(() => {
		// Skip verificarea dacă suntem pe calculator-taxe
		if (pathname === '/calculator-taxe' || pathname === '/delete-acc' || pathname === '/termeni-si-conditii' || pathname === '/politica-de-confidentialitate' || pathname === '/politica-cookies') {
			return;
		}
		
		const loggedIn = !!userService.userValue;
		if (!loggedIn && redirectURL) {
			window.location.href = redirectURL;
		}
	}, [redirectURL, pathname]);

	return !!userService.userValue;
}